import { Typography } from "@mui/material";
import React, { useMemo } from "react";

const InfoItemValue = ({
  children,
  fontSize,
  color = "#0f172a",
  sx,
  variant = "body2",
  ellipsis = false,
  maxLines = 1,
}) => {
  const styles = useMemo(() => {
    return {
      fontSize: fontSize,
      color,
      fontWeight: 600,
      wordBreak: ellipsis ? undefined : "break-word",
      ...(ellipsis && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: 0,
        ...(maxLines === 1
          ? { whiteSpace: "nowrap" }
          : {
              display: "-webkit-box",
              WebkitLineClamp: maxLines,
              WebkitBoxOrient: "vertical",
              whiteSpace: "normal",
            }),
      }),
      ...sx,
    };
  }, [sx, fontSize, color, ellipsis, maxLines]);

  return (
    <Typography variant={variant} sx={styles}>
      {children}
    </Typography>
  );
};

export default InfoItemValue;
